const FolderOpenOutlined = ({ size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    fill='none'
    viewBox='0 0 24 24'
  >
    <path
      fill='#25314C'
      d='M22.439 11.403a2.23 2.23 0 0 0-1.94-1.111h-.749V10c0-2.418-1.332-3.75-3.75-3.75h-5.689l-1.78-1.78a.75.75 0 0 0-.53-.22h-3c-2.418 0-3.75 1.332-3.75 3.75v10.496l.002.011c0 .39.101.78.308 1.133a2.23 2.23 0 0 0 1.941 1.11h12.781c1.36 0 2.615-.736 3.277-1.92l2.903-5.201a2.22 2.22 0 0 0-.024-2.226M5 5.75h2.689l1.78 1.78c.141.141.331.22.53.22h6c1.577 0 2.25.673 2.25 2.25v.292L7.72 10.286h-.003a3.75 3.75 0 0 0-3.278 1.922l-1.689 3.03V8c0-1.577.673-2.25 2.25-2.25m16.153 7.148-2.903 5.201a2.25 2.25 0 0 1-1.967 1.152H3.502a.74.74 0 0 1-.647-.369.73.73 0 0 1-.008-.735L5.75 12.94a2.25 2.25 0 0 1 1.968-1.152h.002l12.779.007c.389 0 .582.259.646.37a.72.72 0 0 1 .008.733'
    />
  </svg>
);

export default FolderOpenOutlined;
